import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://dundlwzoomxcqbulnylj.supabase.co';

// ⚠️ IMPORTANTE: Reemplaza esta clave con tu ANON KEY real
// Ve a tu dashboard de Supabase > Settings > API > anon public
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImR1bmRsd3pvb214Y3FidWxueWxqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDQ5MzUxNDAsImV4cCI6MjA2MDUxMTE0MH0.Zhpv_6T5o03HJM65PCfz4QpD41Ehl56ML7qRMDoRfks';
                         

// Configuración adicional para el cliente de Supabase (persistente en todos los entornos)
const supabaseOptions = {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true
  }
};

const supabase = createClient(supabaseUrl, supabaseAnonKey, supabaseOptions);

// Función auxiliar para manejar errores de peticiones
const handleRequest = async (request) => {
  try {
    const response = await request;
    if (response.error) {
      console.error('Error en la petición:', response.error);
      throw response.error;
    }
    return response;
  } catch (error) {
    console.error('Error en la petición:', error);
    throw error;
  }
};

export { supabase, handleRequest };
